<script setup lang="ts">
const props = defineProps<{
  hero: {
    title: string;
    subtitle: string;
    features: Record<
      string,
      {
        image: string;
        title: string;
        description: string;
      }
    >;
  };
  themeKeys: {
    bg: string;
    title: string;
    subtitle: string;
    featureTitle: string;
    featureDescription: string;
  };
}>();
</script>

<template>
  <div
    class="outer-p-container"
    :style="{
      backgroundColor: props.themeKeys.bg,
    }"
  >
    <div class="inner-container">
      <h1
        class="text-4xl lg:text-5xl font-semibold mb-2 lg:mb-4 text-center"
        :style="{
          color: props.themeKeys.title,
        }"
      >
        {{ props.hero.title }}
      </h1>
      <p
        class="w-4/5 mx-auto text-center mb-6 lg:mb-12"
        :style="{
          color: props.themeKeys.subtitle,
        }"
      >
        {{ props.hero.subtitle }}
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-min gap-8 lg:gap-16 m-4 md:m-8">
        <div
          v-for="feature in Object.values(props.hero.features)"
          :key="feature.title"
          class="flex flex-row items-center gap-4"
        >
          <div
            class="size-20 aspect-square"
          >
            <NuxtImg
              class="h-full w-full object-contain"
              :src="feature.image"
              role="decoration"
            />
          </div>
          <div>
            <h2
              class="font-semibold text-lg lg:text-xl mb-1"
              :style="{
                color: props.themeKeys.featureTitle,
              }"
            >
              {{ feature.title }}
            </h2>
            <p
              class="text-sm"
              :style="{
                color: props.themeKeys.featureDescription,
              }"
            >
              {{ feature.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
